var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDashed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.75,
    stroke: "#848588",
    strokeWidth: 0.5,
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 8.66663C12.1417 8.66663 12.2565 8.78142 12.2565 8.92304V11.7435H15.077C15.2186 11.7435 15.3334 11.8583 15.3334 12C15.3334 12.1416 15.2186 12.2564 15.077 12.2564H12.2565V15.0769C12.2565 15.2185 12.1417 15.3333 12.0001 15.3333C11.8585 15.3333 11.7437 15.2185 11.7437 15.0769V12.2564H8.92316C8.78155 12.2564 8.66675 12.1416 8.66675 12C8.66675 11.8583 8.78155 11.7435 8.92316 11.7435H11.7437V8.92304C11.7437 8.78142 11.8585 8.66663 12.0001 8.66663Z",
    fill: "#848588"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDashed);
export default __webpack_public_path__ + "static/media/add-dashed.eca9657b44009517e5fe3225ae0f1f7e.svg";
export { ForwardRef as ReactComponent };